import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { Store } from "@ngrx/store";
import { filter, map, take } from "rxjs";
import { AuthActions } from "../store/actions";
import { user } from "../../modules/shared/app-user/store/selectors";
import { RedirectorService } from "../services/redirector.service";

export const authGuard: CanActivateFn = (_route, state) => {
    const globalStore = inject(Store);
    const redirectorService = inject(RedirectorService);

    return globalStore.select(user).pipe(
        filter((appUser) => appUser !== undefined),
        take(1),
        map((appUser) => {
            if (!appUser) {
                globalStore.dispatch(AuthActions.login({ redirect: state.url }));
                return false;
            }

            // Follow the saved post-login redirect, or continue to the current URL.
            return redirectorService.resolveRedirect(state.url);
        }),
    );
};
